<div>
	<h1 class="page-header">Logs</h1>
</div>
<div class="row">
	<div class="col-md-5">
		<div class="breadcrumb-container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item active" aria-current="page">Logs:</li>
					@if(filter.action) {
					<li class="breadcrumb-item active">Action: {{ filter.action }}</li>
					}
					@if(filter.model && filter.action != 'loginlogout') {
					<li class="breadcrumb-item active">Model: {{ filter.model }}</li>
					}
				</ol>
			</nav>
		</div>
	</div>
	<div class="col-md-7 mb-2">
		<div class="d-flex gap-3 ms-auto align-items-center justify-content-end">


			<div class="buttons">
				<button type="button" class="btn btn-outline-primary me-2 timerange-btn" [ngbPopover]="timeRangeFilters"
					[autoClose]="false" triggers="manual" #p="ngbPopover" placement="bottom" (click)="p.open()"
					popoverTitle="Time Range">
					{{selectedRangeLabel }} <i class="fa fa-caret-down" aria-hidden="true"></i>

				</button>

				<!-- <button type="button" class="btn btn-outline-secondary me-2" (click)="p.close()">Click me to close a popover</button> -->
			</div>
			@if(filter.action == 'update'){
			<div class="form-check form-switch d-flex align-items-center">
				<label class="form-check-label" for="showTaskSwitch">Show Task</label>
				<input class="form-check-input ms-2" type="checkbox" id="showTaskSwitch" [(ngModel)]="showTask"
					(click)="onShowTaskToggle()" (keyup.enter)="onShowTaskToggle()" tabindex="0" />
			</div>
			}
			<!-- Search Filter -->
			<div class="form-group d-flex align-items-center mb-0">
				<div class="input-group align-items-center">
					<input type="text" id="searchCountry" class="form-control form-control-font"
						[placeholder]="(filter.action == 'create' || filter.action == 'update') || filter.model == 'Booking' && filter.action != 'loginlogout' ? 'Search by user, id, school name' : 'Search by user'"
						[(ngModel)]="searchQuery" style="width: 250px; height: 32px;" (keyup.enter)="onSearchClick()" />
					<span class="input-group-text" style="height: 32px; cursor: pointer;" (click)="onSearchClick()"
						[class.disabled]="!searchQuery">
						<i class="fa fa-search"></i>
					</span>
				</div>

				<div>
					@if(searchQuery != ''){
					<button type="button" ngbTooltip="Clear Search" placement="top"
						class="btn btn-outline-secondary btn-sm d-flex align-items-center ms-1" style="height: 32px;"
						(click)="onClearFilters()" title="Refresh">
						<i class="fa fa-trash"></i>
					</button>
					}

				</div>
			</div>
			<div>

			</div>
			<!-- Button to Open the Offcanvas -->
			<button class="btn btn-outline-primary btn-sm d-flex align-items-center" style="height: 32px;"
				(click)="openEnd(contentCanvas)">
				<i class="fa fa-filter"></i>
			</button>
			<button type="button" class="btn btn-outline-primary btn-sm d-flex align-items-center" style="height: 32px;"
				(click)="onRefreshClick()" title="Refresh">
				<i class="fa fa-refresh"></i>
			</button>
		</div>
	</div>
</div>

<div class="table-responsive">
	<!-- Table: Show when logsData is loaded and not empty -->
	<table class="table table-bordered table-sm">
		<thead>
			<tr>
				<!-- <th>Id<span><i class="fa fa-sort-amount-desc ms-1" aria-hidden="true"></i></span></th> -->
				<th scope="col">
					<div class="d-flex">
						Action
						<div ngbDropdown class="d-inline-block ms-2">
							<i class="fa fa-filter" id="logsAction" ngbDropdownToggle tabindex="0"></i>
							<div ngbDropdownMenu aria-labelledby="logsAction">
								<!-- <button ngbDropdownItem (click)="onLogsActionClick('loginlogout')">Login /
									Logout</button> -->
								<button ngbDropdownItem (click)="onLogsActionClick('create')">Create</button>
								<button ngbDropdownItem (click)="onLogsActionClick('update')">Update</button>
							</div>
						</div>
					</div>
				</th>
				@if(filter.action != 'loginlogout'){
				<th scope="col">
					<div class="d-flex">
						@if((filter.action == 'create' ) && (filter.model == 'SchoolMyTeacher')){
						School Name
						}@else{
						Page
						}
						<div ngbDropdown class="d-inline-block ms-2" id="logsModel">
							<!-- <i class="fa fa-filter" ngbDropdownToggle></i>
							<div ngbDropdownMenu aria-labelledby="logsModel">
								<button ngbDropdownItem (click)="onLogsModelClick('')">All</button>
								@for (page of pages; track page) {
								<button ngbDropdownItem (click)="onLogsModelClick(page.key)">
									{{ page.value }}
								</button>
								}
							</div> -->
						</div>
					</div>
				</th>
				}
				@if((filter.action == 'create') && filter.model == 'SchoolMyTeacher'){
				<th scope="col">
					Teacher Name
				</th>
				}
				<!-- <th scope="col">
					<div class="d-flex">
						User
					</div>
				</th> -->
				@if (filter.action == 'create' && filter.model == 'Booking'){
				<th scope="col" class="min-width-160">School Name</th>
				}@else if (filter.action == 'loginlogout'){
				<th scope="col" class="min-width-160">User</th>
				}
				<th scope="col" class="min-width-160">
					@if(filter.action == 'create' && (filter.model == 'InviteTeacher' || filter.model ==
					'InviteSchool')){
					School Name
					}@else if(filter.action == 'create'){
					Created at
					}@else if (filter.action == 'update') {
					Updated at
					}@else if (filter.action == 'loginlogout') {
					Date
					}
				</th>
				@if (filter.action == 'create' && (filter.model == 'InviteTeacher' || filter.model == 'InviteSchool')) {
				<th scope="col">Teacher Name</th>
				}@else if(filter.action == 'create' || filter.action == 'update'){
				@if (filter.action == 'create' && (filter.model == 'Teacher' ||filter.model == 'Booking' || filter.model
				=='SchoolMyTeacher' || filter.model == 'School' || filter.model == 'SmartGroup' || filter.model ==
				'SchoolAdditionalUser')) {
				<th scope="col">Created by</th>
				}
				<!-- @else{
				<th scope="col">School name</th>
				} -->
				@if (filter.action == 'update') {
				<th scope="col">Updated by</th>
				}
				}
				<th scope="col">IP Address</th>
				@if(filter.model == 'Booking' && filter.action != 'loginlogout'){
				<th scope="col">Booking ID</th>
				}

				<!-- <th scope="col" class="min-width-200">User Agent</th> -->
				<th scope="col" class="sticky-info">Info</th>
			</tr>
		</thead>
		<tbody>
			@for (log of logsData; track log.id) {
			@if (logsData.length > 0 && !isLoading) {
			<tr>
				<!-- <td>{{ log.id }}</td> -->
				<td>{{ log.action }}</td>
				@if(filter.model != 'SchoolMyTeacher' || (filter.model == 'SchoolMyTeacher' && filter.action ==
				'update')) {
				@if(filter.action != 'loginlogout'){
				<td>{{ log.model }}</td>
				}
				}

				<!-- <td>{{ log.user }}</td> -->
				@if ((filter.action == 'create') && (filter.model == 'Booking' || filter.model == 'SchoolMyTeacher')) {
				<td>{{ log.new_fields?.['school_name'] }}</td>
				}
				@if((filter.action == 'create') && filter.model == 'SchoolMyTeacher'){
				<td>{{ log.new_fields?.['teacher_name'] }}</td>
				}@else if (filter.action == 'loginlogout'){
				<td>{{ log?.user }}</td>
				}
				<td>
					@if(filter.action == 'create' && (filter.model == 'InviteTeacher' || filter.model ==
					'InviteSchool')){
					{{ log.new_fields?.['school_name'] }}
					}
					@else if(filter.action == 'create'){
					{{ log.created_at | timezone }}
					}
					@else if (filter.action == 'update') {
					{{ log.updated_at | timezone }}
					}
					@else if (filter.action == 'loginlogout') {
					{{ log.date_time | timezone }}
					}
				</td>
				@if(filter.action == 'create' && (filter.model == 'InviteTeacher' || filter.model == 'InviteSchool')){
				<td>{{ log.new_fields?.['fullname'] }}</td>
				}@else if(filter.action == 'create'){
				@if (filter.action == 'create' && filter.model != 'School') {
				<td>{{ log.created_by }}</td>
				}
				@else if(filter.model !== 'SchoolMyTeacher'){
				<td>{{ log.new_fields?.['title'] }}</td>
				}
				}@else if(filter.action == 'update') {
				<td>{{ log.updated_by }}</td>
				}
				<td>{{ log.ip }}</td>
				@if(filter.model == 'Booking' && filter.action != 'loginlogout'){
				<td>{{ log.object_id }}</td>
				}
				<!-- @if((filter.action == 'create' || filter.action == 'update') || filter.model == 'Booking' &&
				filter.action != 'loginlogout'){
				<td>{{ log.object_id }}</td> } -->
				<!-- <td>
                <span [ngbTooltip]="log.user_agent" placement="top">
                  {{ log.user_agent | textTruncate:40 }}
                </span>
              </td> -->
				<td class="sticky-info">
					<div class="d-flex align-items-center">
						<!-- <button class="btn btn-sm btn-outline-primary" (click)="open(content, log)"
                  [disabled]="!(log.action === 'CREATE' || log.action === 'UPDATE')">
                  <i class="fa fa-eye"></i>
                </button> -->
						@if (actionsToShow[filter.action].showinfoPage) {
						<button class="btn btn-sm btn-outline-secondary ms-2" (click)="navigateToLogsView(log)"
							title="View Log Details">
							<i class="fa fa-info-circle"></i>
						</button>
						}
						@if (actionsToShow[filter.action].showCollapse) {
						<button class="btn btn-sm btn-outline-secondary ms-2" type="button"
							(click)="log._collapsed = !log._collapsed" title="Toggle Details">
							<i class="fa"
								[ngClass]="{'fa-chevron-down': !log._collapsed, 'fa-chevron-up': log._collapsed}"></i>
						</button>
						}
					</div>
				</td>
			</tr>
			}
			@if (log._collapsed) {
			<tr>
				<td colspan="10">
					<div [ngbCollapse]="!log._collapsed" class="p-3 bg-light border rounded">
						@if (actionsToShow[filter.action].showCollapse) {
						<app-login-logout [logData]="log"></app-login-logout>
						}
						@else if (actionsToShow[filter.action].showCollapse) {
						<app-create-view [logData]="log"></app-create-view>
						}
						@else if (actionsToShow[filter.action].showCollapse) {
						<app-update-view [logData]="log" [props]="showTask"></app-update-view>
						}
					</div>
				</td>
			</tr>
			}
			}
			@if (!isLoading && logsData.length === 0) {
			<tr>
				<td colspan="10">
					<div class="d-flex flex-column justify-content-center align-items-center" style="height: 120px;">
						<i class="fa fa-info-circle text-muted mb-2" style="font-size: 2rem;"></i>
						<span class="text-muted">No logs found</span>
					</div>
				</td>
			</tr>
			}
			@if (isLoading) {
			<tr>
				<td colspan="10">
					<div class="d-flex justify-content-center align-items-center" style="height: 120px;">
						<div class="spinner-border text-primary" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</div>
				</td>
			</tr>
			}
		</tbody>
	</table>
</div>

<div class="p-2 clearfix">
	<div class="float-start">
		<ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" [boundaryLinks]="true"
			(pageChange)="onPageChange($event)">
			<ng-template ngbPaginationPages let-page let-pages="pages">
				@if (pages.length > 0) {
				<li class="ngb-custom-pages-item">
					<div class="mb-3 d-flex flex-nowrap px-2">
						<label id="paginationInputLabel" for="paginationInput"
							class="col-form-label me-2 ms-1">Page</label>
						<input #i type="text" inputmode="numeric" pattern="[0-9]*"
							class="form-control custom-pages-input" id="paginationInput" [value]="page"
							(keyup.enter)="selectPage(i.value)" (blur)="selectPage(i.value)"
							(change)="formatInput($any($event).target)"
							aria-labelledby="paginationInputLabel paginationDescription" style="width: 2.5rem" />
						<span id="paginationDescription" class="col-form-label text-nowrap px-2"> of {{ pages.length
							}}</span>
					</div>
				</li>
				}
			</ng-template>
		</ngb-pagination>
	</div>
	<div class="float-end">
		<select class="form-select" style="width:auto" [(ngModel)]="pageSize" (change)="fetchAuditLogs()">
			<option [ngValue]="30">30 items per page</option>
			<option [ngValue]="50">50 items per page</option>
			<option [ngValue]="100">100 items per page</option>
		</select>
	</div>
</div>

<!-- Offcanvas for Filters -->
<ng-template #contentCanvas let-offcanvas>
	<div class="offcanvas-header">
		<h6 class="offcanvas-title">Filters</h6>
		<button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Close click')"></button>
	</div>
	<div class="offcanvas-body">
		<!-- Area Filter -->
		<div class="form-group mb-3">
			<label for="filterArea" class="form-label">Area</label>
			<select id="filterArea" class="form-select form-select-sm form-control-font">
				<option value="">Day: 4days</option>
				<option value="small">Last Week</option>
				<option value="medium">Last Month</option>
				<option value="large">Last Year</option>
			</select>
		</div>

		<!-- Date Filter -->
		<div class="form-group mb-3">
			<label for="dateFilter" class="form-label">Date</label>
			<div class="input-group">
				<input class="form-control" placeholder="dd-mm-yyyy" name="dp" [(ngModel)]="dateFilter" ngbDatepicker
					#d="ngbDatepicker" />
				<button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
					<i class="fa fa-calendar"></i>
				</button>
			</div>
		</div>

		<!-- Search Button -->
		<div class="text-start">
			<button type="button" class="btn btn-outline-primary btn-sm" (click)="onSearchClick()" title="Search">
				<i class="fa fa-search"></i> Search
			</button>
		</div>
	</div>
</ng-template>

<!-- Popover content as a separate template -->
<ng-template #timeRangeFilters>
	<div>
		<!-- Time range options -->
		<div *ngFor="let option of timeOptions">
			<div class="form-check">
				<input class="form-check-input" type="radio" name="timeRange" [id]="option.value" [value]="option.value"
					[(ngModel)]="selectedRange">
				<label class="form-check-label" [for]="option.value">
					{{ option.label }}
				</label>
			</div>
		</div>

		<!-- Custom Range Inputs -->
		<div *ngIf="selectedRange === 'custom'" class="row">
			<div class="col-6">
				<label class="form-label small">Start Time</label>
				<input type="date" class="form-control form-control-sm mb-1" [(ngModel)]="customStartDate">
				<input type="time" class="form-control form-control-sm" [(ngModel)]="customStartTime">
			</div>
			<div class="col-6">
				<label class="form-label small">End Time</label>
				<input type="date" class="form-control form-control-sm mb-1" [(ngModel)]="customEndDate">
				<input type="time" class="form-control form-control-sm" [(ngModel)]="customEndTime">
			</div>
		</div>
		<hr class="hr-no-margin mt-3" />
		<!-- Buttons -->
		<div class="d-flex justify-content-end mt-2">
			<button class="btn btn-sm btn-secondary me-2" (click)="applyRange(p)">Apply</button>
			<button class="btn btn-sm btn-outline-grey" (click)="p.close()">Cancel</button>
		</div>
	</div>
</ng-template>




<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>